"use client";

import { CookieBanner } from "@c15t/nextjs";

interface ConsentBannerProps {
  title?: string;
  description?: string;
  acceptButtonText?: string;
  rejectButtonText?: string;
  customizeButtonText?: string;
}

export function ConsentBanner({
  title = "We value your privacy",
  description = "We use cookies to enhance your browsing experience and analyse our traffic.",
  acceptButtonText = "Accept All",
  rejectButtonText = "Decline All",
  customizeButtonText = "Customise"
}: ConsentBannerProps) {
  return (
    <CookieBanner
      acceptButtonText={acceptButtonText}
      customizeButtonText={customizeButtonText}
      description={description}
      rejectButtonText={rejectButtonText}
      theme={{
        "banner.card":
          "bg-background border border-border rounded-lg shadow-lg",
        "banner.footer": "mt-4 flex justify-end gap-2",
        "banner.footer.accept-button":
          "inline-flex shrink-0 items-center justify-center rounded-md font-medium text-sm ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 h-10 px-4 py-2 bg-primary text-primary-foreground hover:bg-primary/90",
        "banner.footer.customize-button":
          "inline-flex shrink-0 items-center justify-center rounded-md font-medium text-sm ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 h-10 px-4 py-2 border border-input bg-background hover:bg-accent hover:text-accent-foreground",
        "banner.footer.reject-button":
          "inline-flex shrink-0 items-center justify-center rounded-md font-medium text-sm ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 h-10 px-4 py-2 border border-input bg-background hover:bg-accent hover:text-accent-foreground",
        "banner.footer.sub-group": "flex flex-col sm:flex-row gap-2",
        "banner.header.description": "text-sm text-muted-foreground",
        "banner.header.root": "space-y-2",
        "banner.header.title": "text-lg font-medium text-foreground",
        "banner.overlay": "fixed inset-0 bg-background/80 backdrop-blur-sm",
        "banner.root":
          "fixed bottom-4 left-1/2 -translate-x-1/2 z-50 w-[calc(100%-2rem)] max-w-md sm:w-[calc(100%-3rem)]"
      }}
      title={title}
    />
  );
}
